import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import { useReport } from '../hooks/useReport'
import { colors } from '../theme/tokens'
import { VehicleNav } from '../components/VehicleNav'
import { IconChart, IconOdo } from '../components/Icons'
import './Report.css'

export function ReportPage() {
  const { t } = useTranslation()
  const {
    vehicles,
    isLoading,
    reportLoading,
    currentVehicle,
    setCurrentVehicle,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    barData,
    totalDistanceLabel,
    totalEngineLabel,
    drivingPct,
    idlePct,
  } = useReport()

  const [openDist, setOpenDist] = useState(true)
  const [openEngine, setOpenEngine] = useState(true)

  const pieData = [
    { name: t('Conduite'), value: drivingPct, color: colors.SECONDARY_BLUE },
    { name: t('Ralenti'), value: idlePct, color: colors.SOFT_PERIWINKLE },
  ]

  return (
    <div className="report">
      <VehicleNav
        vehicles={vehicles}
        selectedId={currentVehicle?._id}
        onSelect={(v) => setCurrentVehicle(v)}
        calendar="period"
        startDate={startDate}
        endDate={endDate}
        onStartDate={setStartDate}
        onEndDate={setEndDate}
      />

      <div className="report__body">
        {isLoading || reportLoading ? (
          <p className="muted">{t('Chargement…')}</p>
        ) : (
          <>
            <article className={`report__acc${openDist ? ' is-open' : ''}`}>
              <button type="button" className="report__acc-head" onClick={() => setOpenDist((v) => !v)}>
                <IconOdo size={22} />
                <div>
                  <strong>{t('Distance parcourue')}</strong>
                  <span>
                    {t('Total parcouru')} : {totalDistanceLabel}
                  </span>
                </div>
                <i className="report__chevron" />
              </button>
              {openDist && (
                <div className="report__acc-body">
                  <ResponsiveContainer width="100%" height={280}>
                    <BarChart data={barData}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#C1D1EA" />
                      <XAxis dataKey="label" stroke="#5D739B" fontSize={12} />
                      <YAxis stroke="#5D739B" fontSize={12} />
                      <Tooltip />
                      <Bar dataKey="value" name="km" fill={colors.SECONDARY_BLUE} radius={[6, 6, 0, 0]} />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              )}
            </article>

            <article className={`report__acc${openEngine ? ' is-open' : ''}`}>
              <button type="button" className="report__acc-head" onClick={() => setOpenEngine((v) => !v)}>
                <IconChart size={22} />
                <div>
                  <strong>{t('Temps moteur')}</strong>
                  <span>
                    {t('Durée totale')} : {totalEngineLabel}
                  </span>
                </div>
                <i className="report__chevron" />
              </button>
              {openEngine && (
                <div className="report__acc-body report__acc-body--pie">
                  <ResponsiveContainer width="100%" height={220}>
                    <PieChart>
                      <Pie
                        data={pieData}
                        dataKey="value"
                        nameKey="name"
                        cx="50%"
                        cy="50%"
                        innerRadius={55}
                        outerRadius={85}
                        paddingAngle={2}
                      >
                        {pieData.map((d) => (
                          <Cell key={d.name} fill={d.color} />
                        ))}
                      </Pie>
                      <Tooltip />
                    </PieChart>
                  </ResponsiveContainer>
                  <div className="report__legend">
                    {pieData.map((d) => (
                      <span key={d.name}>
                        <i style={{ background: d.color }} />
                        {d.name} <b>{d.value}%</b>
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </article>
          </>
        )}
      </div>
    </div>
  )
}
